var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 17C33 25.8354 25.8377 33 17 33C8.16228 33 1 25.8354 1 17C1 8.16459 8.16228 1 17 1C25.8377 1 33 8.16459 33 17Z",
    fill: "#145DA0",
    stroke: "#145DA0",
    strokeWidth: 0.32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.724 16.1572V12.8849C13.1848 13.4468 12.2187 15.4796 12.2187 16.8678C12.1969 17.595 12.7263 19.2056 13.1848 19.7104C13.7657 20.3499 15.3954 21.6935 15.3954 22.7182V29.9237C15.3954 29.9237 15.3954 30.2542 14.9369 30.2542C11.1544 30.2542 3.442 25.6929 3.32738 16.8678C3.22155 8.7203 10.1064 3.43182 16.7053 3.43182C25.1382 3.43182 30.0178 10.7035 30.0178 16.8678C30.0178 27.4943 20.406 29.8906 19.1615 30.1716C18.1659 30.3964 18.0262 30.1551 18.0808 30.0063V22.7182C18.0808 21.5547 19.5381 20.395 19.9147 20.1235C20.2913 19.852 21.1592 18.0577 21.1592 16.8678C21.1592 14.5144 19.4999 13.232 18.6703 12.8849V16.1572L16.7053 17.4297L14.724 16.1572Z",
    fill: "white",
    stroke: "#145DA0",
    strokeWidth: 0.32
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7793 18.6196H27.1033C26.4974 22.2795 24.6635 24.863 21.2412 26.5853V22.7763C22.1582 22.0311 23.6646 20.0272 23.7793 18.6196Z",
    fill: "#145DA0",
    stroke: "#145DA0",
    strokeWidth: 0.32
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69713 14.7028H6.30762C6.30762 12.5874 9.87071 5.76202 16.7218 5.62981C23.3698 5.50152 27.2015 12.4222 27.2015 14.7028H23.9266C23.3589 12.7748 21.1233 8.9285 16.7218 8.96817C12.3203 9.00781 9.69713 13.4303 9.69713 14.7028Z",
    fill: "#145DA0",
    stroke: "#145DA0",
    strokeWidth: 0.32
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66387 18.6031H6.33984C6.94571 22.2554 8.77967 24.8336 12.2019 26.5523V22.7512C11.2849 22.0075 9.77849 20.0078 9.66387 18.6031Z",
    fill: "#145DA0",
    stroke: "#145DA0",
    strokeWidth: 0.32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logo-blue.f865a307bdf0674aa34de0050ee1187c.svg";
export { ForwardRef as ReactComponent };